module.exports = __webpack_public_path__ + "img/target-board.0bcf7e71.svg";